module.exports = __webpack_public_path__ + "static/media/Expansions_card_bg_05.0875ec55.jpg";